import styles from './UniverseBackground.module.css'

export function UniverseBackground({theme}: {theme?: string}) {
  if (!theme) return null

  // We could have used the Primer Image component, however, this is not displayed on mobile.
  // Using CSS modules + background image allows us to avoid sending an unused network request on mobile
  return (
    <div
      className={styles.universeBackground}
      style={{'--background-image-url': `url(/images/modules/site/landing-pages/universe-23-waitlist/${theme}.webp)`}}
    />
  )
}
